'use strict';

angular.module('lmsApp')
    .factory('Account', function Account($resource, $rootScope) {
        return $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        $rootScope.user = response.data;
                        return response;
                    }
                }
            }
        });
    });
